module.exports = __webpack_public_path__ + "static/scale-model-of-caswell-sculpture-in-gresham-oregon-a906380133e4e2210f06edb90b6e1730.png";